import { Inject, Injectable, InjectionToken } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ActionCreator } from '@ngrx/store';
import { SessionTokenService } from 'app/modules/darwin/services/session-token.service';
import { LoadSessionTokenAction, SessionTokenActions } from 'app/modules/darwin/store/session-token/session-token.actions';
import { toErrorMessage } from 'app/modules/main/helper/error-mapper';
import { WindowService } from 'app/modules/main/services/window.service';
import { EMPTY } from 'rxjs';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SessionTokenEffects {

  static readonly LOAD =
    new InjectionToken<ActionCreator[]>('LOAD');

  constructor(
    private readonly actions: Actions,
    private readonly sessionTokenClient: SessionTokenService,
    private readonly windowService: WindowService,
    @Inject(SessionTokenEffects.LOAD)
    private readonly loadSessionTokenActions: LoadSessionTokenAction[] = [],
  ) {
  }

  readonly load = createEffect(
    () => this.actions.pipe(
      ofType(...this.loadSessionTokenActions.flat()),
      switchMap(() => this.fetchSessionToken()),
    )
  );

  private fetchSessionToken() {

    return this.sessionTokenClient.fetch()
      .pipe(
        tap((token) => !token?.length && this.storeLocationAndLogIntoDarwin()),
        map(SessionTokenActions.sessionTokenLoaded),
        catchError((error: any) =>
          error.status !== 0
            ? of(SessionTokenActions.sessionTokenLoadFailed(toErrorMessage(error)))
            : EMPTY
        ),
      );
  }

  public storeLocationAndLogIntoDarwin(): void {

    document.cookie =
      'sessionRedirect=' +
      encodeURIComponent(window.location.pathname + window.location.search) +
      ';path=/';

    this.windowService.redirectToLoginPage();
  }

}
